<template lang="pug">
.filtering__search
  i.ico-search(aria-hidden="true")
  label.sr-only(for="form-search") Tax and compliance forms search
  input#form-search.filtering__search-input(
    type="search",
    v-model="model",
    placeholder="Enter search terms..."
  )
  //- input.sr-only(type='submit' value='Submit your search')
</template>


<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "FilteringSearch",
  computed: {
    ...mapGetters(["search"]),
    model: {
      get() {
        return this.search;
      },
      set(value) {
        this.setSearch(value);
      },
    },
  },
  methods: {
    ...mapMutations(["setSearch"]),
  },
};
</script>

<style lang="scss" scoped>
.filtering__search-input {
  &:focus {
    outline: none !important;
  }
}
</style>

<style lang="scss" scoped>
.filtering__search {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  background: lighten($gray, 2.5%);
  border: 1px solid darken($gray, 5%);
  box-shadow: 0 0 0.25rem rgba($black, 0.075);
  border-radius: 0.3875rem;
  padding: 0 0.25rem 0 1rem;
  &:focus-within {
    outline: 3px solid $casablanca;
  }

  i {
    font-size: 1.5rem;
    line-height: 1;
    font-weight: 700;
    color: darken($gray, 7.5%);
    margin-top: 2px;
  }

  input {
    appearance: none;
    border: none;
    padding: 0.75rem;
    background: transparent;
    flex: 1 1 100%;
  }
}
</style>